<template>
  <div>
    <div class="kit__utils__heading">
        <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
    </div>
    <div class="card">
        <div class="card-header">
          <b-row>
            <b-col cols="12" lg="6" md="12">
              <b-col>
                <b-col>
                  <b-form-group label-cols-sm="3" label="ค้นหาแบบพิเศษ" class="mb-0">
                    <a-input-search v-model="formkey.keyWord" placeholder="" enter-button="Search" @search="setKeyword"
                      allow-clear />
                    <span class="form-text"><span class="text-danger">*</span>ค้นหาด้วย <span
                        class="text-danger">ชื่อบัญชีธนาคาร</span> หรือ <span class="text-danger">เลขบัญชีธนาคาร</span></span>
                  </b-form-group>
                </b-col>
              </b-col>
            </b-col>
            <b-col cols="6" lg="6" md="6">
              <b-col>
                <b-col>
                  <div class="d-flex justify-content-end" style="margin: 3px;">
                <a class="btn btn-primary" href="javascript: void(0);" @click="showModal('insert')">เพิ่มบัญชีธนาคาร</a>
                  </div>
                </b-col>
              </b-col>
            </b-col>
          </b-row>
        </div>
        <!-- <div class="card-header card-header-flex">
        </div> -->
        <div class="card-body">
          <div class="card-header card-header-flex">
            <div class="d-flex flex-column justify-content-center mr-auto">
                <h5 class="mb-0">{{(this.$route.params.bankSetId !== 'all' && this.$route.params.bankSetId > 0) ? 'บัญชีธนาคาร :' : ''}} {{ (this.$route.params.bankSetId !== 'all' && this.$route.params.bankSetId > 0) ? this.accountName : '' }}</h5>
            </div>
            <div class="d-flex flex-column justify-content-center" style="margin: 3px;">
              <a class="btn btn-primary" href="javascript: void(0);" @click="refreshData()"><i
                  class="fe fe-rotate-cw mr-1" /> รีเฟรช</a>
            </div>
          </div>
          <a-table :columns="columns" :dataSource="data" rowKey='bankServiceId' size="middle" :scroll="{ x: 1300 }"
          :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true }">
            <!-- <h6 slot="bankServiceType" slot-scope="text">
              <b-badge pill :variant="(text === 1)?'success':'danger'">{{(text === 1)?'บัญชีรับ':(text === 2)?'บัญชีถอน':"ไม่พบข้อมํูล"}}</b-badge>
            </h6> -->
            <div
            slot="filterDropdown"
            slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
            class="custom-filter-dropdown"
          >
            <a-input
              v-ant-ref="c => searchInput = c"
              :placeholder="`Search ${column.dataIndex}`"
              :value="selectedKeys[0]"
              @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
              @pressEnter="() => handleSearch(selectedKeys, confirm)"
              style="width: 188px; margin-bottom: 8px; display: block;"
            />
            <a-button
              type="primary"
              @click="() => handleSearch(selectedKeys, confirm)"
              size="small"
              style="width: 90px; margin-right: 8px"
            >Search</a-button>
            <a-button
              @click="() => handleReset(clearFilters)"
              size="small"
              style="width: 90px"
            >Reset</a-button>
          </div>
          <a-icon
            slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"
          />
          <a-button slot="bankPIN" slot-scope="text,record" type="primary" icon="lock" size="small" @click="showBankPIN(record.bankServiceId)">แสดงข้อมูล</a-button>
            <span slot="bankServiceType" slot-scope="text">
              <a-tag :color="(text === 1)?'green':'red'">
                  {{(text === 1)?'บัญชีรับ':(text === 2)?'บัญชีถอน':(text === 3)?'บัญชีถอนคืนลูกค้า':(text === 4)?'บัญชีถอนคอมมิชชั่น':"ไม่พบข้อมํูล"}}
              </a-tag>
            </span>
            <h6 slot="status" slot-scope="status,record">
              <b-badge pill href="#" @click="useAction(record.bankServiceId,status)"  :variant="getStatus('bankSet',status).color">{{getStatus('bankSet',status).name}}</b-badge>
            </h6>
            <span slot="Action" slot-scope="text,record">
              <a-dropdown>
                <a-menu slot="overlay">
                  <a-menu-item @click="showModal('update',record.bankServiceId)">แก้ไขบัญชี </a-menu-item>
                  <!-- <a-menu-item @click="detailStatement(record.bankServiceId)">ดูสเตทเม้น</a-menu-item>
                  <a-menu-item @click="pullStatement(record.bankServiceId)">ดึงสเตทเม้น </a-menu-item>
                  <a-menu-item @click="matchStatement(record.bankServiceId)">จับคู่สเตทเม้น </a-menu-item> -->
                </a-menu>
            <a-button style="margin-left: 8px"> จัดการ <a-icon type="down" /> </a-button>
          </a-dropdown>
            </span>
          </a-table>
        </div>
    </div>
    <a-modal :title="this.form.title" v-model="visible" ok-text="ยืนยัน" cancel-text="ยกเลิก" @ok="handleOk" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="form" layout="vertical" :rules="rules">
        <div class="row">
          <div class="col-md-6">
            <!-- ชุดบัญชี -->
            <a-form-model-item label="ชุดบัญชี" prop="bankSetId">
              <a-select :disabled="(form.bankSetId !== '' && form.type === 'update' || this.$route.params.bankSetId !== 'all')" v-model="form.bankSetId" placeholder="กรุณาเลือกข้อมูล">
                <a-select-option v-for="(item , index) in bankSet" :key="index" :value="item.bankSetId">
                    {{ item.bankSetName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </div>
          <div class="col-md-6">
            <a-form-model-item label="เลขบัญชี" prop="accountNumber">
              <a-input v-model="form.accountNumber" />
            </a-form-model-item>
          </div>
          <div class="col-md-12">
            <a-form-model-item label="ธนาคาร" prop="bankId">
              <a-select v-model="form.bankId" placeholder="กรุณาเลือกข้อมูล">
                <a-select-option v-for="(item , index) in banks" :key="index" :value="item.id">
                    {{ item.shortName }} {{ `(${item.short})` }}
                </a-select-option>
              </a-select>
             </a-form-model-item>
          </div>
          <!-- <div class="col-md-6" v-show="(form.bankId !== 5)">
            <a-form-model-item label="ยูสเซอร์เนม">
              <a-input v-model="form.accountUsername" />
            </a-form-model-item>
          </div> -->
          <!-- <div class="col-md-6" v-show="(form.bankId !== 5)">
            <a-form-model-item label="พาสเวิร์ด">
              <a-input-password v-model="form.accountPassword" />
            </a-form-model-item>
          </div> -->
          <div class="col-md-12">
            <a-form-model-item label="PIN" prop="bankPIN">
              <a-input-password v-model="form.bankPIN" />
            </a-form-model-item>
          </div>
          <!-- <div class="col-md-12" v-show="(form.bankId === 5 || form.bankId === 7)">
            <a-form-model-item label="DeviceId">
              <a-input-password v-model="form.deviceId" />
            </a-form-model-item>
          </div>
          <div class="col-md-12" v-show="(form.bankId === 6)">
            <a-form-model-item label="SCB Register Logs">
              <a-textarea v-model="form.logSCBRegister" />
            </a-form-model-item>
          </div>
          <div class="col-md-12" v-show="(form.bankId === 6)">
            <a-form-model-item label="เปิดใช้งาน Kbank App ">
              <a-switch v-model="form.kbankAppStatus" />
            </a-form-model-item>
          </div> -->
          <div class="col-md-6">
            <a-form-model-item label="ฝาก/ต่ำสุด" prop="depositMin">
              <a-input-number style="width: 100%" v-model="form.depositMin" />
            </a-form-model-item>
          </div>
          <div class="col-md-6">
            <a-form-model-item label="ฝาก/สูงสุด" prop="depositMax">
              <a-input-number style="width: 100%" v-model="form.depositMax" />
            </a-form-model-item>
          </div>
          <div class="col-md-6">
            <a-form-model-item label="ถอน/ต่ำสุด" prop="withdrawMin">
              <a-input-number style="width: 100%" v-model="form.withdrawMin" />
            </a-form-model-item>
          </div>
          <div class="col-md-6">
            <a-form-model-item label="ถอน/สูงสุด" prop="withdrawMax">
              <a-input-number style="width: 100%" v-model="form.withdrawMax" />
            </a-form-model-item>
          </div>
          <div class="col-md-6">
            <a-form-model-item label="ยอดเงินต่ำสุดควรโยก" prop="tranferMaxCount">
              <a-input-number style="width: 100%" v-model="form.tranferMaxCount" />
            </a-form-model-item>
          </div>
          <div class="col-md-6">
            <a-form-model-item label="ยอดเงินสูงสุดรับได้ต่อวัน" prop="tranferMaxDate">
              <a-input-number style="width: 100%" v-model="form.tranferMaxDate" />
            </a-form-model-item>
          </div>
            <div class="col-md-6">
              <a-form-model-item label="สถานะ">
              <a-select v-model="form.bankServiceStatus" prop="bankServiceStatus">
                <a-select-option :value="0">
                  รอตรวจสอบ
                </a-select-option>
                <a-select-option :value="1">
                  เปิดใช้งาน
                </a-select-option>
                <a-select-option :value="2">
                  ปิดใช้งาน
                </a-select-option>
                <a-select-option :value="3">
                  เลิกใช้งาน
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </div>
        </div>
      </a-form-model>
    </a-modal>
    <a-modal :title="this.formDetail" v-model="visibleDetail" ok-text="ยืนยัน" cancel-text="ยกเลิก"  @ok="handleOkDetail" @cancel="handleCancelDetail"  width="80%">
      <a-table :columns="columnsDetail" :dataSource="dataDetail" rowKey='time' size="middle" :scroll="{ x: 1300 }">
        <a slot="actionAmountInCome" slot-scope="text, record"
            :style="setColor('amountIn')">{{record.type === 'Deposit'?setComma(record.value):setComma(0)}}</a>
        <a slot="actionAmountOutCome" slot-scope="text, record"
            :style="setColor('amountOut')">{{record.type !== 'Deposit'?setComma(record.value):setComma(0)}}</a>
      </a-table>
    </a-modal>
    <a-modal v-model="modelGetPaymentDetail" title="เลือกวันที่" ok-text="ยืนยัน" cancel-text="ยกเลิก" showCancelButton="false"  @ok="useModalGetPaymentDetail">
        <a-form-model ref="rulesPayment" :model="formPayment" :rules="rulesPayment">
            <a-form-model-item label="วันที่" prop="date">
              <!-- <a-input v-model="form.selectDate" /> -->
              <a-date-picker v-model="formPayment.date" format="YYYY-MM-DD" placeholder="วันที่" style="width: 100%" />
            </a-form-model-item>
            <!-- <a-form-model-item label="คู่ค้า" prop="operatorCode">
              <a-select v-model="form.operatorCode"  placeholder="กรุณาเลือกข้อมูล" @select="setOperator">
                <a-select-option value="">
                  กรุณาเลือกข้อมูล
                </a-select-option>
                <a-select-option v-for="(item , index) in operator" :key="index" :value="item.operatorCode">
                    {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item> -->
        </a-form-model>
    </a-modal>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
import { getName } from '@/utils/status'
import apiClient from '@/services/api'
import axios from 'axios'
// import moment from 'moment'
import Swal from 'sweetalert2'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  data() {
    return {
      data: [],
      dataDetail: [],
      bankSet: [],
      bank: [
        {
          bankId: 4,
          bankName: 'ธ.กรุงไทย (ktb)',
        },
        {
          bankId: 5,
          bankName: 'ธ.ไทยพาณิชย์ (scb)',
        },
        {
          bankId: 6,
          bankName: 'ธ.กสิกรไทย (kbank)',
        },
        {
          bankId: 7,
          bankName: 'ธ.ออมสิน (gsb)',
        },
      ],
      columns: [
        {
          title: 'ลำดับ',
          width: 60,
          // key: 'bankServiceId',
          dataIndex: 'bankServiceId',
        },
        {
          title: 'บัญชี',
          // key: 'bankServiceSystem',
          dataIndex: 'bankServiceSystem',
          filters: [
            { text: 'scb', value: 5 },
            { text: 'kbank', value: 6 },
            { text: 'ktb', value: 4 },
            { text: 'gsb', value: 7 },
          ],
          width: 200,
          onFilter: (value, record) => record.bankId.toString().includes(value.toString()),
        },
        {
          title: 'PIN',
          width: 125,
          // key: 'balance',
          dataIndex: 'bankServiceId',
          scopedSlots: { customRender: 'bankPIN' },
        },
        {
          title: 'เงินในบัญชี',
          width: 125,
          // key: 'balance',
          dataIndex: 'balance',
          customRender: (text, row, index) => {
            return parseFloat(text).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
        {
          title: 'ฝาก/ต่ำสุด',
          width: 200,
          // key: 'tranferMax',
          dataIndex: 'depositMin',
          customRender: (text, row, index) => {
            return parseFloat(text).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
        {
          title: 'ฝาก/สูงสุด',
          width: 200,
          // key: 'tranferMax',
          dataIndex: 'depositMax',
          customRender: (text, row, index) => {
            return parseFloat(text).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
        {
          title: 'ฝาก/ต่ำสุด',
          width: 200,
          // key: 'tranferMax',
          dataIndex: 'withdrawMin',
          customRender: (text, row, index) => {
            return parseFloat(text).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
        {
          title: 'ฝาก/สูงสุด',
          width: 200,
          // key: 'tranferMax',
          dataIndex: 'withdrawMax',
          customRender: (text, row, index) => {
            return parseFloat(text).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
        {
          title: 'ยอดเงินต่ำสุดที่ควรโยก',
          width: 200,
          // key: 'tranferMax',
          dataIndex: 'tranferMaxCount',
          customRender: (text, row, index) => {
            return parseFloat(text).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
        {
          title: 'ยอดเงินสูงสุดที่รับได้/วัน',
          width: 200,
          // key: 'tranferMax',
          dataIndex: 'tranferMaxDate',
          customRender: (text, row, index) => {
            return parseFloat(text).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
        {
          title: 'สถานะ',
          // key: 'status',
          filters: [
            { text: 'รอตรวจสอบ', value: 0 },
            { text: 'เปิดใช้งาน', value: 1 },
            { text: 'ปิดใช้งาน', value: 2 },
            { text: 'เลิกใช้งาน', value: 3 },
          ],
          dataIndex: 'bankServiceStatus',
          scopedSlots: { customRender: 'status' },
          fixed: 'right',
          onFilter: (value, record) => record.bankServiceStatus.toString().includes(value.toString()),
        },
        {
          title: 'ตัวเลือก',
          key: 'Action',
          dataIndex: 'bankServiceId',
          fixed: 'right',
          scopedSlots: { customRender: 'Action' },
        },
      ],
      columnsDetail: [
        // {
        //   title: 'ID',
        //   key: 'bank_id',
        //   dataIndex: 'bank_id',
        // },
        {
          title: 'เวลาทำรายการ',
          dataIndex: 'str_date',
        },
        {
          title: 'เงินเข้า',
          // key: 'value',
          // dataIndex: 'value',
          scopedSlots: { customRender: 'actionAmountInCome' },
        },
        {
          title: 'เงินออก',
          // key: 'value',
          // dataIndex: 'value',
          scopedSlots: { customRender: 'actionAmountOutCome' },
        },
        {
          title: 'คงเหลือ',
          key: 'balance',
          dataIndex: 'balance',
          customRender: (text, row, index) => {
            return parseFloat(text).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
        {
          title: 'ช่องทาง',
          key: 'chanel',
          dataIndex: 'chanel',
          // customRender: (text, row, index) => {
          //   return parseFloat(text).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          // },
        },
        {
          title: 'ธนาคารที่โอน',
          width: 200,
          key: 'transfer',
          dataIndex: 'transfer',
          // customRender: (text, row, index) => {
          //   return parseFloat(text).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          // },
        },
        {
          title: 'รายละเอียด',
          width: 200,
          key: 'detail',
          dataIndex: 'detail',
          // customRender: (text, row, index) => {
          //   return parseFloat(text).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          // },
        },
      ],
      visible: false,
      visibleDetail: false,
      modelGetPaymentDetail: false,
      accountName: '',
      formDetail: '',
      form: {
        title: '',
        bankSetId: '',
        bankServiceId: '',
        accountNumber: '',
        depositMin: 0,
        depositMax: 0,
        withdrawMin: 0,
        withdrawMax: 0,
        tranferMaxCount: 0,
        tranferMaxDate: 0,
        bankPIN: '',
        bankServiceStatus: 0,
      },
      formkey: {
        keyWord: '',
      },
      formPayment: {
        date: '',
        bankServiceId: '',
      },
      rulesPayment: {
        date: [
          { required: true, message: 'กรุณาวันที่', trigger: 'blur' },
        ],
      },
      rules: {
        accountNumber: [
          { required: true, message: 'กรุณากรอกเลขบัญชี', trigger: 'blur' },
        ],
        bankSetId: [
          { required: true, message: 'กรุณาเลือกชุดบัญชี', trigger: 'blur' },
        ],
        bankId: [
          { required: true, message: 'กรุณาเลือกธนาคาร', trigger: 'blur' },
        ],
        bankPIN: [
          { required: true, message: 'กรุณากรอก PIN', trigger: 'blur' },
        ],
        depositMin: [
          { required: true, message: 'กรุณากรอกรับขั้นต่ำ', trigger: 'blur' },
        ],
        depositMax: [
          { required: true, message: 'กรุณากรอกรับสูงสุด', trigger: 'blur' },
        ],
        withdrawMin: [
          { required: true, message: 'กรุณากรอกถอนขั้นต่ำ', trigger: 'blur' },
        ],
        withdrawMax: [
          { required: true, message: 'กรุณากรอกถอนสูงสุด', trigger: 'blur' },
        ],
        tranferMaxCount: [
          { required: true, message: 'กรุณากรอกต่ำสุดโยกเงิน', trigger: 'blur' },
        ],
        tranferMaxDate: [
          { required: true, message: 'กรุณากรอกยอดสูงสุดรับได้ต่อวัน', trigger: 'blur' },
        ],
        bankServiceStatus: [
          { required: true, message: 'กรุณาเลือกสถานะ', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    handleSearch(selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    pullStatement(bankServiceId) {
      if (bankServiceId !== null) {
        this.getStatementList(bankServiceId)
      }
    },
    getStatementList(bankServiceId) {
      Swal.fire({
        title: 'Please Wait !',
        showConfirmButton: false,
        onOpen: function () {
          Swal.showLoading()
        },
      })
      axios.get(`https://apibankthadmin.duckbet.com/banks/loadtransactionbank/${bankServiceId}`).then(res => {
      // axios.get(`http:/localhost:3005/banks/loadtransactionbank/${bankServiceId}`).then(res => {
        if (res.data.code === '000') {
          // console.log(res.data.responseData)
          if (typeof res.data.responseData.data !== 'undefined' || res.data.responseData.status === true) {
            if (res.data.responseData.data.data.length > 0) {
              Toast.fire({ icon: 'success', title: 'ทำรายการสำเร็จ' })
              this.visibleDetail = true
              this.getNameBank(bankServiceId)
              this.dataDetail = res.data.responseData.data.data
            } else {
              Toast.fire({ icon: 'error', title: 'ไม่พบรายการ' })
            }
          } else {
            Toast.fire({ icon: 'error', title: 'ไม่สามารถทำรายการได้' })
          }
        } else {
          Toast.fire({ icon: 'error', title: res.data.message })
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    matchStatement(bankServiceId) {
      if (bankServiceId !== null) {
        this.getMatchStement(bankServiceId)
      }
    },
    getMatchStement(bankServiceId) {
      Swal.fire({
        title: 'Please Wait !',
        showConfirmButton: false,
        onOpen: function () {
          Swal.showLoading()
        },
      })
      apiClient.get(`/bankService/getMatchStement/${bankServiceId}`).then(res => {
        // console.log(res)
        if (res.data.code === '000') {
          const iconError = (res.data.code === '000') ? 'success' : 'error'
          Toast.fire({ icon: iconError, title: res.data.message })
        } else {
          // Toast.fire({ icon: 'error', title: 'Unable to view data, bank must be deactivated.' })
          Toast.fire({ icon: 'error', title: res.data.message })
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    getNameBank(bankServiceId) {
      apiClient.get(`/bankService/getNameBank/${bankServiceId}`).then(res => {
        if (res.data.code === '000') {
          this.formDetail = res.data.responseData.data[0].bankServiceSystem
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    clearForm() {
      this.form = {
        type: 'insert',
        title: '',
        bankSetId: '',
        bankServiceId: '',
        accountNumber: '',
        depositMin: 0,
        depositMax: 0,
        withdrawMin: 0,
        withdrawMax: 0,
        tranferMaxCount: 0,
        tranferMaxDate: 0,
        bankPIN: '',
        bankServiceStatus: 0,
      }
    },
    clearFormPayment() {
      this.formPayment = {
        date: '',
        bankServiceId: '',
      }
    },
    showBankPIN (id) {
      apiClient.get(`/bankService/getPIN/${id}`).then(res => {
        if (res.data.code === '000') {
          const data = res.data.responseData.data[0]
          Swal.fire({
            icon: 'info',
            title: 'ข้อมูล PIN',
            html: `<h1 style="color: black; font-weight: 800;">${data.bankPIN}</h1>`,
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'คุณไม่มีสิทธิ์เรียกดูข้อมูล',
          })
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    showModal(type, id = null) {
      // get OpertorCode
      this.clearForm()
      this.form.type = type
      this.form.title = (type === 'insert') ? 'เพิ่มบัญชีธนาคาร' : 'แก้ไขบัญชีธนาคาร'

      apiClient.get('/bankService/getBankSet').then(res => {
        if (res.data.code === '000') {
          this.bankSet = []
          this.bankSet = res.data.responseData.data
          if (type === 'update') {
            this.getDataBankService(id)
          } else {
            if (this.$route.params.bankSetId !== 'all') this.form.bankSetId = parseInt(this.$route.params.bankSetId)
            this.visible = !this.visible
          }
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    getDataBankService(bankServiceId) {
      apiClient.get(`/bankService/${bankServiceId}`).then(res => {
        if (res.data.code === '000') {
          const dataBankService = res.data.responseData.data[0]

          this.form.bankServiceId = bankServiceId
          this.form.bankId = dataBankService.bankId
          this.form.bankPIN = dataBankService.bankPIN
          this.form.bankSetId = dataBankService.bankSetId
          this.form.accountNumber = dataBankService.accountNumber
          this.form.depositMin = dataBankService.depositMin
          this.form.depositMax = dataBankService.depositMax
          this.form.withdrawMin = dataBankService.withdrawMin
          this.form.withdrawMax = dataBankService.withdrawMax
          this.form.tranferMaxCount = dataBankService.tranferMaxCount
          this.form.tranferMaxDate = dataBankService.tranferMaxDate
          this.form.tranferMax = dataBankService.tranferMax
          this.form.bankServiceStatus = dataBankService.bankServiceStatus
          this.visible = !this.visible
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    async getBankService() {
      // เช็คถ้าไม่มี Id ส่งเข้ามา ให้ดึงทั้งหมด
      // console.log("tt",this.$route.params)
      if (this.$route.params.bankSetId !== 'all') {
        this.getName()
      }

      await apiClient.put(`/bankService/getData/${this.$route.params.bankSetId}`, this.formkey).then(response => {
        const res = response.data
        if (res.code === '000') {
          this.data = res.responseData.data

          if (this.data.length > 0) {
            const listOperater = this.data.map(function(item, pos) {
              return { text: item.operatorName, value: item.operatorName }
            })
            this.columns[1].filters = [
              ...new Map(listOperater.map((item) => [item.text, item])).values(),
            ]
          }
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
    async getName() {
      await apiClient.get(`/bankService/getName/${this.$route.params.bankSetId}`).then(response => {
        const res = response.data
        if (res.code === '000') {
          this.accountName = res.responseData.data[0].name
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
    setKeyword(value, event) {
      this.getBankService()
    },
    onSubmit() {
      const title = (this.form.type === 'update') ? 'แน่ใจหรือไม่ที่ต้องการแก้ไข' : 'แน่ใจหรือไม่ที่ต้องการเพิ่มข้อมูล'
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          Swal.fire({
            icon: 'info',
            title: title,
            showCancelButton: true,
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก',
            showLoaderOnConfirm: true,
            preConfirm: (value) => {
              if (value) {
                // ส่งข้อมูลอัปเดทสถานะ
                if (this.form.bankServiceId !== '') {
                  return apiClient.put(`bankService/update/${this.form.bankServiceId}`, this.form).then(response => {
                    if (response.status !== 200) {
                      throw new Error(response.message)
                    }
                    return response.data
                  }).catch(error => {
                    Swal.showValidationMessage(
                      `เกิดข้อผิดพลาด: ${error}`,
                    )
                  })
                } else {
                  return apiClient.post('bankService/create', this.form).then(response => {
                    if (response.status !== 200) {
                      throw new Error(response.message)
                    }
                    return response.data
                  }).catch(error => {
                    Swal.showValidationMessage(
                      `เกิดข้อผิดพลาด: ${error}`,
                    )
                  })
                }
              }
            },
            allowOutsideClick: () => !Swal.isLoading(),
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              // console.log(result.value)
              const iconError = (result.value.code === '000') ? 'success' : 'error'
              Toast.fire({ icon: iconError, title: result.value.message })
              this.visible = false
              this.confirmLoading = false
              this.getBankService()

              // if (result.value.responseData.checkOTP === true) {
              //   this.submitOTP(result.value.responseData.bankServiceId)
              // }
            }
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    async submitOTP(bankServiceId) {
      // sent otp
      await Swal.fire({
        title: 'แน่ใจหรือไม่ที่ต้องการตรวจสอบ OTP',
        icon: 'question',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showCancelButton: true,
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: (value) => {
          if (value) {
            return apiClient.post('/bankService/registerscb', { bankserviceid: bankServiceId }).then(response => {
              if (response.status !== 200) {
                throw new Error(response.message)
              }
              return response.data
            }).catch(error => {
              Swal.showValidationMessage(
                `Request failed: ${error}`,
              )
            })
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.isConfirmed) {
          if (result.value.responseData.smsServiceCheck) {
            const iconError = (result.value.code === '000') ? 'success' : 'error'
            Toast.fire({ icon: iconError, title: result.value.message + ' Error : ' + result.value.responseData.error.error })
            this.getBankService()
          } else {

          }
        }
      })
    },
    async getBanks() {
      await apiClient.get('/banks').then(response => {
        const res = response.data
        if (res.code === '000') {
          this.banks = res.responseData.data
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
    // confirmOTPSCB(){
    //   if (sentOTP.code === '000') {
    //     Swal.fire({
    //       title: 'กรุณากรอกข้อมูล OTP ที่ได้รับ',
    //       html:
    //         '<input id="otp" class="swal2-input" placeholder="กรุณากรอกข้อมูล"></input>',
    //       focusConfirm: false,
    //       showCancelButton: true,
    //       confirmButtonText: 'ยืนยัน',
    //       cancelButtonText: 'ยกเลิก',
    //       preConfirm: (value) => {
    //         if (value) {
    //           const otp = document.getElementById('otp').value
    //           if (otp === '') {
    //             Swal.showValidationMessage(
    //               'กรุณากรอกข้อมูล',
    //             )
    //           } else {
    //             const data = {
    //               otp: otp,
    //               bankserviceid: bankServiceId,
    //             }

    //             return apiClient.post('/bankService/scbotp', data).then(response => {
    //               if (response.status !== 200) {
    //                 throw new Error(response.message)
    //               }
    //               return response.data
    //             }).catch(error => {
    //               Swal.showValidationMessage(
    //                 `Request failed: ${error}`,
    //               )
    //             })
    //           }
    //         }
    //       },
    //       allowOutsideClick: () => !Swal.isLoading(),
    //     }).then((result) => {
    //       if (result.isConfirmed) {
    //         const iconError = (result.value.code === '000') ? 'success' : 'error'
    //         Toast.fire({ icon: iconError, title: result.value.message })
    //         this.getBankService()
    //       }
    //     })
    //   } else {
    //     Swal.showValidationMessage(
    //       `Request failed: ${sentOTP.message}`,
    //     )
    //   }
    // },
    handleOk(e) {
      this.onSubmit()
    },
    handleCancel(e) {
      this.visible = false
    },
    handleOkDetail(e) {
      this.visibleDetail = false
    },
    handleCancelDetail(e) {
      this.visibleDetail = false
    },
    setComma(value) {
      if (value !== 0 && value !== null) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      } else {
        return '-'
      }
    },
    setColor(value) {
      if (value === 'amountIn') {
        return 'color: #14ab84'
      } else {
        return 'color: #f04e3f'
      }
    },
    getStatus(type, status) {
      const styleEl = getName(type, status)[0]
      if (styleEl.color === 'black') {
        styleEl.color = 'dark'
      }

      return styleEl
    },
    useAction(bankServiceId, status) {
      if (status === 0 || status === 2 || status === 4 || status === 3) this.updateBankStatus(bankServiceId, 'openAuto')
      if (status === 1) this.updateBankStatus(bankServiceId, 'closeBank')
      if (status === 7) this.submitOTP(bankServiceId)
    },
    async updateBankStatus(bankServiceId, type) {
      const bankServiceStatus = (type === 'openAuto') ? 1 : (type === 'closeBank') ? 2 : null
      const title = (type === 'openAuto') ? 'คุณแน่ใจหรือไม่ที่ต้องการเปิดใช้งานอัตโนมัติ' : (type === 'closeBank') ? 'คุณแน่ใจหรือไม่ที่ต้องการปิดการใช้งานอัตโนมัติ' : null

      if (bankServiceStatus) {
        await Swal.fire({
          title: title,
          icon: 'question',
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก',
          showCancelButton: true,
          showCloseButton: true,
          showLoaderOnConfirm: true,
          preConfirm: (value) => {
            if (value) {
              const data = { bankServiceId: bankServiceId, bankServiceStatus }
              return apiClient.post('/bankService/updateStatus', data).then(response => {
                if (response.status !== 200) {
                  throw new Error(response.message)
                }
                return response.data
              }).catch(error => {
                Swal.showValidationMessage(
                  `Request failed: ${error}`,
                )
              })
            }
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
          if (result.isConfirmed) {
            const iconError = (result.value.code === '000') ? 'success' : 'error'
            Toast.fire({ icon: iconError, title: result.value.message })
            this.getBankService()
          }
        })
      }
    },
    closeBankSerivce(bankPaymentId) {
    },
    refreshData() {
      this.loading(true)
      this.getBankService()
      this.loading(false)
    },
    async loading(e) {
      if (e) {
        Swal.fire({
          title: 'กำลังตรวจสอบ',
          text: 'ระบบกำลังตรวจสอบข้อมูล กรุณารอสักครู่.',
          showConfirmButton: false,
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
      } else {
        Swal.close()
      }
    },
    detailStatement(bankServiceId) {
      this.modelGetPaymentDetail = !this.modelGetPaymentDetail
      this.clearFormPayment()
      this.formPayment.bankServiceId = bankServiceId
    },
    useModalGetPaymentDetail(e) {
      this.$refs.rulesPayment.validate(valid => {
        if (valid) {
          // console.log(this.form)
          this.sendGetPaymentDetail()
        }
      })
    },
    async sendGetPaymentDetail() {
      Swal.fire({
        title: 'Please Wait !',
        showConfirmButton: false,
        onOpen: function () {
          Swal.showLoading()
        },
      })

      await apiClient.post('bankService/getMatchStement/forDate', this.formPayment).then(response => {
        const iconError = (response.data.code === '000') ? 'success' : 'error'
        Swal.hideLoading()
        this.modelGetPaymentDetail = !this.modelGetPaymentDetail

        if (iconError === 'success') {
          // console.log(response.data.responseData.data)
          if (typeof response.data.responseData.data !== 'undefined') {
            if (response.data.responseData.data.data.length > 0) {
              Toast.fire({ icon: 'success', title: 'ทำรายการสำเร็จ' })
              this.visibleDetail = true
              // this.getNameBank(bankServiceId)
              this.dataDetail = response.data.responseData.data.data
            } else {
              Toast.fire({ icon: 'error', title: 'ไม่พบรายการ' })
            }
          } else {
            Toast.fire({ icon: 'error', title: 'ไม่สามารถทำรายการได้' })
          }
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
  },
  async created() {
    await this.getBankService()
    await this.getBanks()
  },

}
</script>

<style>

</style>
